export const soloareApiCommonHeader = {
    'X-SOLOARE-REQUEST': 1
}